export const SZAK_KOMM_TRANSLATIONS = {
    hu: {
        esgTitle: "ESG 1.7 Információkezelés",
        pageTitle: "14. A szak kommunikációja",
        
        section1: {
            title: "14.1. Felvételi kommunikáció, beiskolázás",
            link: "Forrás:",
            felvetelInfo: "Felvételi információk linkje (több válasz is jelölhető)",
            informacioMinoseg: "Információk minősége",
            hirdetesek: "A közösségi médiában megjelenő hirdetések bemutatása (ha volt ilyen)",
            kozossegiMediaPlatformok: "Használt közösségi média platformok (több válasz is jelölhető)",
            kozossegiMediaStrategia: "Közösségi média stratégia értékelése",
        },
        
        section2: {
            title: "14.2. Megtörtént-e a tartalom és kommunikációs forma egyeztetése az alábbi szervezeti egységekkel",
            kommunikacioIgazgatosag: "Kommunikációért és Sajtókapcsolatokért Felelős Igazgatósággal",
            szolgaltatIgazgatosag: "Szolgáltatási és Brand Igazgatósággal",
        },
        
        section3: {
            title: "14.3. Kommunikációs aktivitás értékelése",
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden mezőt ki kell tölteni!"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    en: {
        esgTitle: "ESG 1.7 Information Management",
        pageTitle: "14. Programme Communication",
        
        section1: {
            title: "14.1. Admissions Communication, Enrollment",
            link: "Source:",
            felvetelInfo: "Links to admissions-related information (multiple answers may be selected)",
            informacioMinoseg: "Quality of information provided",
            hirdetesek: "Description of advertisements published on social media (if applicable)",
            kozossegiMediaPlatformok: "Social media platforms used (multiple answers may be selected)",
            kozossegiMediaStrategia: "Assessment of the social media strategy",
        },
        
        section2: {
            title: "14.2. Coordination of Content and Communication Formats with the Following Organizational Units",
            kommunikacioIgazgatosag: "Directorate for Communications and Media Relations",
            szolgaltatIgazgatosag: "Directorate for Services and Brand Management",
        },
        
        section3: {
            title: "14.3. Assessment of Communication Activities",
        },
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Revert Finalization"
        },
        
        alerts: {
            requiredFields: "All fields must be filled in!"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};
